/**
 * A helper class which extends Error and overwrites the name of the exception.
 *
 * @class ImportPollingStatusError
 */
export default class ImportPollingStatusError extends Error {
  constructor(status) {
    super(
      `Status "${status}" is not allowed, make sure the gravity does not return anything other then 'scheduled', 'busy', 'complete', 'retry', 'failed'`,
    )
    this.name = 'ImportPollingStatusError'
  }
}
